import { createGlobalStyle } from 'styled-components';
import grid from './grid';
import palette from './palette';

export const theme = {
  ...grid,
  palette,
  fonts: {
    primary: "'Montserrat', 'Avenir Next', sans-serif",
    secondary: '-apple-system, BlinkMacSystemFont, Roboto, sans-serif',
  },
  anim: {
    dur: `${(1 / 3).toFixed(3)}s`,
  },
};

/*
  A helper function to generate a special StyledComponent that handles global styles.
  Normally, styled components are automatically scoped to a local CSS class and
  therefore isolated from other components. In the case of createGlobalStyle,
  this limitation is removed and things like CSS resets or base stylesheets can be applied.
*/

export const GlobalStyle = createGlobalStyle`
  ${'' /* html, body {
    font-family: 'Montserrat', 'Avenir Next', sans-serif;
    font-weight: 500;
  } */}
  *,
  *:before,
  *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  button {
    border: none;
    border-radius: 0;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    line-height: normal;
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    -webkit-appearance: none;
    cursor: pointer;
    outline: none;
  }

  button, a, input[type=range] {
    &:focus {
      outline: 1px dashed ${(props) => props.theme.palette.label};
    }
  }

  input[type=range] {
    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
    width: 100%; /* Specific width is required for Firefox. */
    background: transparent; /* Otherwise white in Chrome */
    margin: 0;
    padding: 0;
  }

  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  input[type=range]:focus {
    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
  }

  input[type=range]::-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
`;
